export const INTEL_FORM_FIELDS = {
  CATEGORY_IDS: 'categoryIds',
  LOCATION_IDS: 'locationIds',
  LOCATION_TIERS: 'locationTiers',
  KEYWORD: 'keyword',
};
